'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _LinkInput = require('./LinkInput');

var _LinkInput2 = _interopRequireDefault(_LinkInput);

var _LinkStateDisplay = require('./LinkStateDisplay');

var _LinkStateDisplay2 = _interopRequireDefault(_LinkStateDisplay);

require('./LinkHeader.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LinkURL = function LinkURL(_ref) {
    var element = _ref.element;

    var url = element.getIn(['content', 'link', 'url']);
    return _react2.default.createElement(
        'div',
        { className: 'link-url' },
        _react2.default.createElement(
            'div',
            null,
            url
        )
    );
};

// Styles


LinkURL.propTypes = {
    element: _propTypes2.default.object
};

var LinkHeader = function LinkHeader(props) {
    var isLoaded = props.element.getIn(['content', 'link', 'url']);

    return _react2.default.createElement(
        'div',
        { className: (0, _classnames2.default)('LinkHeader', { loaded: isLoaded }) },
        _react2.default.createElement(_LinkStateDisplay2.default, props),
        !isLoaded ? _react2.default.createElement(_LinkInput2.default, props) : _react2.default.createElement(LinkURL, props)
    );
};

LinkHeader.propTypes = {
    element: _propTypes2.default.object
};

exports.default = LinkHeader;


//////////////////
// WEBPACK FOOTER
// ./src/client/element/link/LinkHeader.js
// module id = 1999
// module chunks = 0